import { NotificationResponse } from '@/types/notification.types';
import { dateUtils } from '@/utils/date.utils';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'sm-notification-item',
  imports: [],
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss',
})
export class NotificationItemComponent {
  translateService = inject(TranslateService);
  @Input() notification!: NotificationResponse;
  @Output() delete = new EventEmitter<number>();
  @Output() onclick = new EventEmitter<NotificationResponse>();

  onDelete(event: MouseEvent, id: number) {
    event.stopPropagation();
    this.delete.emit(id);
  }

  onClick(notif: NotificationResponse, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.onclick.emit(notif);
  }

  formatDate(date: string): string {
    return dateUtils.formatDateTimeToTimeAgo(date, this.translateService);
  }

  // UI helpers
  isRead(isRead: boolean): string {
    return !isRead ? 'border-2 border-primary shadow-md rounded-md' : 'opacity-80';
  }
}
